import request from '@/utils/request'

// 登记记录列表
export function disJobOrderLogList(data) {
  return request({
    url: '/disJobOrderLog/list',
    method: 'post',
    data
  })
}
//民安检弹窗
export function dataMyPageList(params) {
  return request({
    url: '/arumData/dataMyPageList',
    method: 'get',
    params
  })
}
//非民安检弹窗
export function dataFmPageList(params) {
  return request({
    url: '/arumData/dataFmPageList',
    method: 'get',
    params
  })
}
//导出
export function jobOrderListExport(params) {
  return request({
    url: '/disJobOrder/jobOrderListExport',
    method: 'post',
    responseType: 'blob', //改变接收的值类型
    data: params
  })
}
// 工单记录列表
export function jobOrderList(data) {
  return request({
    url: '/disJobOrder/jobOrderList',
    method: 'post',
    data
  })
}
// 解决
export function solve(data) {
  return request({
    url: '/disJobOrderLog/solve',
    method: 'post',
    data
  })
}

// 编辑
export function update(data) {
  return request({
    url: '/disJobOrderLog/update',
    method: 'post',
    data
  })
}
// 7,8编辑
export function orderUpdate(data) {
  return request({
    url: '/disJobOrder/updateJobOrder',
    method: 'post',
    data
  })
}
// 新增
export function disJobOrderLogSave(data) {
  return request({
    url: '/disJobOrderLog/save',
    method: 'post',
    data
  })
}
// 7,8新增
export function disJobOrderSave(data) {
  return request({
    url: '/disJobOrder/save',
    method: 'post',
    data
  })
}

// 被表扬对象
export function findDeptUserTree(params) {
  return request({
    url: '/dept/findDeptUserTree',
    method: 'get',
    params
  })
}

// 派工
export function dispatchOrder(data) {
  return request({
    url: '/disJobOrder/dispatchOrder',
    method: 'post',
    data
  })
}

// 转派
export function updateRecCompany(data) {
  return request({
    url: '/disJobOrder/updateRecCompany',
    method: 'get',
    params: data
  })
}

// 作废
export function abandonOrder(data) {
  return request({
    url: '/disJobOrder/abandonOrder',
    method: 'get',
    params: data
  })
}

// 召回
export function returnBack(data) {
  return request({
    url: '/disJobOrder/returnBack',
    method: 'get',
    params: data
  })
}

// 回退至系统
export function returnBackSystem(data) {
  return request({
    url: '/disJobOrder/returnBackSystem',
    method: 'get',
    params: data
  })
}
// 催办
export function sendHurry(data) {
  return request({
    url: '/disJobOrder/sendHurry',
    method: 'get',
    params: data
  })
}
//处置详情(报修开通巡检)
export function collectItemHisDetail(data) {
  return request({
    url: '/disJobOrder/collectItemHisDetail',
    method: 'get',
    params: data
  })
}
//退费记录
export function refundLog(data) {
  return request({
    url: '/disJobOrderRefund/refundLog',
    method: 'post',
    data
  })
}
export function getCheckItem(data) {
  return request({
    url: '/disJobOrder/getCheckItem',
    method: 'get',
    params: data
  })
}

//工单操作流
export function operLog(data) {
  return request({
    url: '/disJobOrder/operLog',
    method: 'post',
    data
  })
}
// 回访
export function followJobOrder(data) {
  return request({
    url: '/disJobOrder/followJobOrder',
    method: 'post',
    data
  })
}

export function getMaterialList(data) {
  return request({
    url: '/disJobOrderMaterial/getMaterialList',
    method: 'get',
    params: data
  })
}

export function getMaterialDetailList(data) {
  return request({
    url: '/disJobOrderMaterial/getMaterialDetailList',
    method: 'get',
    params: data
  })
}
